import React, { useEffect, useState } from "react";
import MenuBar from "./MenuBar";
import axios from "axios";
import style from "./PaymentRecived.module.css";
import DateRangePicker from "./DateRangePicker";
import pdfIcon from "./assets/pdf.png";
import { toast } from "react-toastify";
import moment from "moment";
import { API_BASE_URL } from "./config.js";
import HeadingBar from "./HeadingBar.js";

const formatDateForAPI = (date) => {
  const d = new Date(date);
  return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(
    2,
    "0",
  )}${String(d.getDate()).padStart(2, "0")}`;
};

const PaymentRecived = () => {
  const isEmbedded = sessionStorage.getItem("mode") === "embedded";
  const vendorDataRaw = sessionStorage.getItem("vendordata");
  const vendorInfo = vendorDataRaw ? JSON.parse(vendorDataRaw) : null;
  const vendorCode = vendorInfo?.CardCode || "";

  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const [paymentrecivedData, setPaymentRecivedData] = useState([]);
  const [fromDate, setFromDate] = useState(
    firstDayOfMonth.toISOString().split("T")[0],
  );
  const [toDate, setToDate] = useState(
    lastDayOfMonth.toISOString().split("T")[0],
  );

  /* 🔴 row-level downloading state */
  const [downloadingDocEntry, setDownloadingDocEntry] = useState(null);

  /* ---------- PDF Download ---------- */
  const handleDownloadPDF = async (item) => {
    try {
      setDownloadingDocEntry(item.DocEntry);

      const response = await fetch(
        `${API_BASE_URL}/PaymentReceived/DownloadSAPPDF?DocNum=${item.DocEntry}`,
      );

      if (!response.ok) throw new Error("Failed to download PDF");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Payment_${item.StarDocNum}_${new Date()
        .toISOString()
        .slice(0, 10)}.pdf`;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      toast.error("Could not download PDF.");
    } finally {
      setDownloadingDocEntry(null);
    }
  };

  const fetchPaymentRecivedData = async (from, to) => {
    if (!vendorCode) return;
    try {
      const res = await axios.get(
        `${API_BASE_URL}/PaymentReceived?VendorCode=${vendorCode}&FromDt=${formatDateForAPI(
          from,
        )}&ToDt=${formatDateForAPI(to)}`,
      );
      setPaymentRecivedData(res.data);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch data.");
    }
  };

  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
    fetchPaymentRecivedData(start, end);
  };

  const handleSearch = () => {
    fetchPaymentRecivedData(fromDate, toDate);
  };

  useEffect(() => {
    const start = moment().startOf("quarter").format("YYYY-MM-DD");
    const end = moment().endOf("quarter").format("YYYY-MM-DD");
    setFromDate(start);
    setToDate(end);
    fetchPaymentRecivedData(start, end);
  }, [vendorCode]);

  return (
    <div className={style.BookedInvoiceDetails}>
      {!isEmbedded && (
        <div className={style.HeadingBarContainer}>
          <HeadingBar />
        </div>
      )}
      <div className={style.BookedInvoiceDetailsContainer}>
        <div className={style.MenuBarContainer}>
          <MenuBar />
        </div>

        <div className={style.MainBookedInvoiceDetailsContainer}>
          <div className={style.MenuNameDetails}>Payment Received</div>

          <div className={style.filterArea}>
            <div className={style.datearea}>
              <DateRangePicker
                onDateChange={handleDateChange}
                startDate={fromDate}
                endDate={toDate}
              />
              <button onClick={handleSearch}>Search</button>
            </div>
          </div>

          <div className={style.MainArea}>
            <div className={style.BookedInvoicetable}>
              <table>
                <thead>
                  <tr>
                    <td>Star Booking #</td>
                    <td>Payment Date</td>
                    <td>NEFT Ref #</td>
                    <td>Payment Mode</td>
                    <td>Transfer Amount</td>
                    <td>Action</td>
                  </tr>
                </thead>

                <tbody>
                  {paymentrecivedData.length ? (
                    paymentrecivedData.map((item, index) => (
                      <tr key={index}>
                        <td>{item.StarDocNum}</td>
                        <td>{item.PaymentDate}</td>
                        <td>{item.NEFTRefNo}</td>
                        <td>{item.PaymentMode || "-"}</td>
                        <td className="text-end amount-cell">
                          {item.DocCur}{" "}
                          {Number(item.TransferAmt).toLocaleString("en-IN")}
                        </td>

                        <td
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: 10,
                          }}
                        >
                          {downloadingDocEntry === item.DocEntry ? (
                            <span style={{ fontSize: 12, color: "#666" }}>
                              Downloading...
                            </span>
                          ) : (
                            <img
                              src={pdfIcon}
                              alt="PDF"
                              title="Download PDF"
                              style={{
                                width: 20,
                                height: 20,
                                cursor: "pointer",
                              }}
                              onClick={() => handleDownloadPDF(item)}
                            />
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" style={{ textAlign: "center" }}>
                        No Payment Recived Found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentRecived;
